import React, { Component, useState, useEffect } from 'react';
import Cards from './cards';
import { getEvents, getAvailableDates, getUserLocation } from '../services/api';
import { Alert, Button, Container, Row, Col, Card, Form, InputGroup } from 'react-bootstrap';
import { withTranslation, useTranslation } from 'react-i18next';
import AboutSection from './AboutSection';
import FAQSection from './FAQSection';
import ContactSection from './ContactSection';
import SEO from './SEO';
import JsonLd from './JsonLd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import LoadingPage from './LoadingPage';
import { Link } from 'react-router-dom';

const FAKE_USERS = [
  { name: 'Sara',   city: 'Milano',  avatar: '👩‍🦰', looking: 'concerti' },
  { name: 'Marco',  city: 'Roma',    avatar: '👨',   looking: 'aperitivi' },
  { name: 'Giulia', city: 'Torino',  avatar: '👩',   looking: 'mostre' },
  { name: 'Luca',   city: 'Bologna', avatar: '👨‍🦱', looking: 'sport' },
  { name: 'Chiara', city: 'Firenze', avatar: '👩‍🦳', looking: 'teatro' },
];

const CommunityTeaser = () => {
  const [online] = useState(() => Math.floor(Math.random() * 80) + 120);
  const [pulse, setPulse] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setInterval(() => setPulse(p => !p), 1200);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      margin: '3rem 0',
      borderRadius: 20,
      background: 'linear-gradient(135deg, rgba(124,58,237,0.12), rgba(236,72,153,0.10))',
      border: '1px solid rgba(124,58,237,0.2)',
      padding: '2rem 1.5rem',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.08em', color: '#a78bfa', textTransform: 'uppercase', marginBottom: '0.5rem' }}>
        Community & Match
      </div>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 800, margin: '0 0 0.4rem', lineHeight: 1.3 }}>
        {t('home.community_title')}
      </h2>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', margin: '0 0 1.25rem' }}>
        {t('home.community_sub')}
      </p>

      {/* Live counter */}
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.25)', borderRadius: 20, padding: '0.3rem 0.9rem', marginBottom: '1.5rem', fontSize: '0.82rem', fontWeight: 700, color: '#34d399' }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#34d399', display: 'inline-block', opacity: pulse ? 1 : 0.3, transition: 'opacity 0.4s' }} />
        {online} {t('home.community_online')}
      </div>

      {/* Fake user cards */}
      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
        {FAKE_USERS.map((u, i) => (
          <div key={i} style={{
            background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(124,58,237,0.18)',
            borderRadius: 14, padding: '0.75rem 1rem', minWidth: 100, textAlign: 'center',
            filter: i >= 3 ? 'blur(3px)' : 'none', userSelect: 'none',
          }}>
            <div style={{ fontSize: '1.6rem', marginBottom: '0.25rem' }}>{u.avatar}</div>
            <div style={{ fontWeight: 700, fontSize: '0.85rem' }}>{u.name}</div>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{u.city}</div>
            <div style={{ fontSize: '0.68rem', color: '#a78bfa', marginTop: 4 }}>{t('home.community_looking')} {u.looking}</div>
          </div>
        ))}
        <div style={{
          background: 'rgba(124,58,237,0.08)', border: '1px dashed rgba(124,58,237,0.3)',
          borderRadius: 14, padding: '0.75rem 1rem', minWidth: 100, textAlign: 'center',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{ fontSize: '1.4rem', marginBottom: '0.25rem' }}>+{online - 5}</div>
          <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{t('home.community_others')}</div>
        </div>
      </div>

      <Link to="/registrati" style={{
        display: 'inline-block', background: 'linear-gradient(135deg,#7c3aed,#ec4899)',
        color: '#fff', fontWeight: 700, fontSize: '0.95rem', borderRadius: 12,
        padding: '0.75rem 2rem', textDecoration: 'none',
        boxShadow: '0 4px 16px rgba(124,58,237,0.35)',
      }}>
        {t('home.community_cta')}
      </Link>
      <p style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '0.6rem', marginBottom: 0 }}>
        {t('home.community_free')}
      </p>
    </div>
  );
};


// Componente di debug per visualizzare lo stato degli eventi
const DebugPanel = ({ show, events, filteredEvents, activeFilters }) => {
  if (!show) return null;
  
  return (
    <Card className="mb-4 bg-light">
      <Card.Header className="bg-dark text-white">Debug Panel</Card.Header>
      <Card.Body>
        <h6>Eventi totali: {events.length}</h6>
        <h6>Eventi filtrati: {filteredEvents.length}</h6>
        <h6>Filtri attivi:</h6>
        <pre>{JSON.stringify(activeFilters, null, 2)}</pre>
        
        <details>
          <summary>Eventi originali (primi 2)</summary>
          <pre>{JSON.stringify(events.slice(0, 2), null, 2)}</pre>
        </details>
        
        <details>
          <summary>Eventi filtrati (primi 2)</summary>
          <pre>{JSON.stringify(filteredEvents.slice(0, 2), null, 2)}</pre>
        </details>
      </Card.Body>
    </Card>
  );
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableDays: [],   // [{date, count, label, sublabel}]
      events: [],          // solo gli eventi del giorno selezionato
      loading: true,       // caricamento iniziale date
      eventsLoading: false, // caricamento eventi del giorno
      error: null,
      userLocation: null,
      locationError: null,
      locationRequested: false,
      maxDistance: 50,
      activeFilters: {
        category: props.selectedCategory || '',
        search: props.searchTerm || '',
        distance: false
      },
      showDebug: false,
      showContactSection: false,
      searchTerm: props.searchTerm || '',
      isRequestingLocation: false,
      locationWarning: null,
      locationHelp: null,
      selectedDay: null, // verrà impostato al primo giorno disponibile
    };
  }

  componentDidMount() {
    this.loadAvailableDays();
    window.addEventListener('showContactSection', this.showContactSection);
    window.addEventListener('hideContactSection', this.hideContactSection);
    window.addEventListener('navigateToHome', this.resetSections);
  }

  componentWillUnmount() {
    // Rimuovi il listener quando il componente viene smontato
    window.removeEventListener('showContactSection', this.showContactSection);
    window.removeEventListener('hideContactSection', this.hideContactSection);
    window.removeEventListener('navigateToHome', this.resetSections);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedCategory !== this.props.selectedCategory ||
      prevProps.searchTerm !== this.props.searchTerm
    ) {
      this.setState(prevState => ({
        activeFilters: {
          ...prevState.activeFilters,
          category: this.props.selectedCategory && this.props.selectedCategory !== 'all' ? this.props.selectedCategory : null,
          search: this.props.searchTerm || ''
        }
      }), () => this.loadAvailableDays());
    }
  }

  // Step 1: carica solo le date disponibili (query leggera)
  loadAvailableDays = async () => {
    this.setState({ loading: true, error: null });
    try {
      const { activeFilters } = this.state;
      const params = {};
      if (activeFilters.category) params['category__name'] = activeFilters.category;
      if (activeFilters.search)   params['search'] = activeFilters.search;

      const dates = await getAvailableDates(params);
      const today = new Date(); today.setHours(0,0,0,0);
      const tomorrow = new Date(today); tomorrow.setDate(today.getDate()+1);
      const DAYS_IT   = ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'];
      const MONTHS_IT = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];

      const availableDays = dates.map(({ date, count }) => {
        const d = new Date(date + 'T00:00:00');
        const diff = Math.round((d - today) / 86400000);
        let label, sublabel;
        if (diff === 0)      { label = this.props.t('home.today');   sublabel = null; }
        else if (diff === 1) { label = this.props.t('home.tomorrow'); sublabel = null; }
        else                 { label = DAYS_IT[d.getDay()]; sublabel = `${d.getDate()} ${MONTHS_IT[d.getMonth()]}`; }
        return { date, count, label, sublabel };
      });

      const todayStr = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;
      const todayOrNext = availableDays.find(d => d.date >= todayStr) || availableDays[0] || null;
      const defaultDay = todayOrNext ? todayOrNext.date : null;
      this.setState({ availableDays, selectedDay: defaultDay, loading: false }, () => {
        if (defaultDay) this.loadEventsForDay(defaultDay);
      });
    } catch (err) {
      this.setState({ loading: false, error: 'Errore nel caricamento degli eventi.' });
    }
  };

  // Step 2: carica gli eventi solo del giorno selezionato
  loadEventsForDay = async (date) => {
    this.setState({ eventsLoading: true });
    try {
      const { activeFilters, userLocation, maxDistance } = this.state;
      const params = { date };
      if (activeFilters.category) params['category__name'] = activeFilters.category;
      if (activeFilters.search)   params['search'] = activeFilters.search;

      let events = await getEvents(params);

      // Filtro distanza client-side (il dataset del singolo giorno è piccolo)
      if (activeFilters.distance && userLocation) {
        events = events.filter(event => {
          if (!event.latitude || !event.longitude) return false;
          const dist = this.calculateDistance(
            userLocation.latitude, userLocation.longitude,
            parseFloat(event.latitude), parseFloat(event.longitude)
          );
          event.distance = dist;
          return dist <= maxDistance;
        });
        events.sort((a, b) => (a.distance || 999) - (b.distance || 999));
      }

      this.setState({ events, eventsLoading: false });
    } catch (err) {
      this.setState({ eventsLoading: false, error: 'Errore nel caricamento degli eventi.' });
    }
  };

  // Calcola la distanza tra due punti usando la formula dell'emisenoverso
  calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Raggio della Terra in km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2); 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    const distance = R * c; // Distanza in km
    return distance;
  };

  deg2rad = (deg) => {
    return deg * (Math.PI/180);
  };

  filterEventsByDistance = (events, location = null) => {
    const userLocation = location || this.state.userLocation;
    
    if (!userLocation) {
      console.log('Nessuna posizione utente disponibile per il filtro distanza');
      return events;
    }
    
    const maxDistance = this.state.maxDistance;
    console.log("Filtraggio eventi entro " + maxDistance + "km dalla posizione utente");
    
    return events.filter(event => {
      // Verifica che l'evento abbia coordinate valide
      if (!event.latitude || !event.longitude) {
        console.log("Evento " + event.id + " - " + event.title + " escluso: coordinate mancanti");
        return false;
      }
      
      // Calcola la distanza
      const distance = this.calculateDistance(
        userLocation.latitude, 
        userLocation.longitude, 
        parseFloat(event.latitude), 
        parseFloat(event.longitude)
      );
      
      // Aggiungi la distanza all'evento per l'ordinamento
      event.distance = distance;
      
      // Debug
      console.log("Evento " + event.id + " - " + event.title + ": distanza " + distance.toFixed(2) + "km");
      
      // Restituisci true se l'evento \xE8 entro la distanza massima
      return distance <= maxDistance;
    });
  };

  filterEvents = () => {
    // I filtri ora vengono applicati lato server — ricarica le date e poi gli eventi
    this.loadAvailableDays();
  };

  // Metodo per richiedere manualmente la posizione dell'utente
  requestLocation = async () => {
    this.setState({ locationError: null, isRequestingLocation: true });
    
    try {
      console.log('Richiesta posizione utente...');
      const userLocation = await getUserLocation();
      console.log('Posizione ottenuta con successo:', userLocation);
      
      this.setState({
        userLocation,
        locationRequested: true,
        isRequestingLocation: false,
        locationWarning: userLocation.isApproximate
          ? "Posizione approssimativa. Per risultati migliori, concedi i permessi di geolocalizzazione." : null
      }, () => {
        if (this.state.selectedDay) this.loadEventsForDay(this.state.selectedDay);
      });
      
      return true;
    } catch (error) {
      console.error('Errore nella geolocalizzazione:', error);
      this.setState({ 
        locationError: error.message || "Non \xE8 stato possibile ottenere la tua posizione.",
        locationRequested: true,
        isRequestingLocation: false
      });
      
      // Mostra un messaggio pi\xF9 dettagliato all'utente
      if (error.message && error.message.includes("PERMISSION_DENIED")) {
        // Suggerimenti specifici per browser
        let browserSpecificHelp = "";
        const userAgent = navigator.userAgent.toLowerCase();
        
        if (userAgent.includes("chrome")) {
          browserSpecificHelp = "In Chrome, clicca sull'icona del lucchetto nella barra degli indirizzi, vai su 'Autorizzazioni del sito' e imposta 'Posizione' su 'Consenti'.";
        } else if (userAgent.includes("firefox")) {
          browserSpecificHelp = "In Firefox, clicca sull'icona a sinistra della barra degli indirizzi, vai su 'Autorizzazioni' e imposta 'Accedi alla posizione' su 'Consenti'.";
        } else if (userAgent.includes("safari")) {
          browserSpecificHelp = "In Safari, vai su Preferenze > Siti web > Posizione e consenti l'accesso per questo sito.";
        }
        
        this.setState({
          locationHelp: browserSpecificHelp || "Controlla le impostazioni di privacy del tuo browser per consentire l'accesso alla posizione."
        });
      }
      
      return false;
    }
  };

  handleDistanceChange = (distance) => {
    this.setState({ maxDistance: distance }, () => {
      if (this.state.selectedDay) this.loadEventsForDay(this.state.selectedDay);
    });
  };

  toggleDistanceFilter = () => {
    this.setState(prevState => ({
      activeFilters: { ...prevState.activeFilters, distance: !prevState.activeFilters.distance }
    }), () => {
      if (this.state.selectedDay) this.loadEventsForDay(this.state.selectedDay);
    });
  };

  // Metodo per mostrare la sezione contatti
  showContactSection = () => {
    this.setState({ showContactSection: true }, () => {
      // Dopo aver impostato lo stato, scorri alla sezione contatti
      const contactSection = document.getElementById('contact-section');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Metodo per nascondere la sezione contatti
  hideContactSection = () => {
    this.setState({ showContactSection: false });
  }
  
  // Metodo per resettare tutte le sezioni dinamiche
  resetSections = () => {
    this.setState({ showContactSection: false });
  }

  // Aggiungi questi metodi per gestire la ricerca
  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleSearch = (e) => {
    e.preventDefault();
    this.setState(prevState => ({
      activeFilters: { ...prevState.activeFilters, search: this.state.searchTerm.trim() || '' }
    }), () => this.loadAvailableDays());
  };

  handleResetSearch = () => {
    this.setState({
      searchTerm: '',
      activeFilters: { ...this.state.activeFilters, search: '' }
    }, () => this.loadAvailableDays());
  };

  // Raggruppa gli eventi per giorno
  groupByDay(events) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const DAYS_IT = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
    const MONTHS_IT = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
      'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

    const groups = {};
    const order = [];

    events.forEach(event => {
      if (!event.start_date) return;
      const d = new Date(event.start_date);
      d.setHours(0, 0, 0, 0);
      const key = d.toISOString().slice(0, 10);

      if (!groups[key]) {
        let label;
        if (d.getTime() === today.getTime()) {
          label = '🎉 Oggi';
        } else if (d.getTime() === tomorrow.getTime()) {
          label = '🔜 Domani';
        } else {
          const diffDays = Math.round((d - today) / 86400000);
          if (diffDays < 0) {
            label = `📅 ${DAYS_IT[d.getDay()]} ${d.getDate()} ${MONTHS_IT[d.getMonth()]}`;
          } else {
            label = `📅 ${DAYS_IT[d.getDay()]} ${d.getDate()} ${MONTHS_IT[d.getMonth()]}`;
            if (d.getFullYear() !== today.getFullYear()) label += ` ${d.getFullYear()}`;
          }
        }
        groups[key] = { label, date: d, events: [] };
        order.push(key);
      }
      groups[key].events.push(event);
    });

    return order.map(k => groups[k]);
  }

  // Estrai i giorni disponibili dagli eventi filtrati
  getAvailableDays(events) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const DAYS_IT = ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'];
    const MONTHS_IT = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];
    const seen = new Set();
    const days = [];
    events.forEach(e => {
      if (!e.start_date) return;
      const d = new Date(e.start_date);
      d.setHours(0,0,0,0);
      const key = d.toISOString().slice(0,10);
      if (seen.has(key)) return;
      seen.add(key);
      let label, sublabel;
      const diff = Math.round((d - today) / 86400000);
      if (diff === 0) { label = 'Oggi'; sublabel = null; }
      else if (diff === 1) { label = 'Domani'; sublabel = null; }
      else { label = DAYS_IT[d.getDay()]; sublabel = `${d.getDate()} ${MONTHS_IT[d.getMonth()]}`; }
      days.push({ key, label, sublabel, date: d });
    });
    return days;
  }

  // Aggiungi questo metodo per generare i dati strutturati
  generateStructuredData() {
    return {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Happy Events",
      "url": "https://eventhappy.it",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://eventhappy.it/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    };
  }

  render() {
    const { availableDays, events, eventsLoading, loading, error, locationError, userLocation, maxDistance, activeFilters, showDebug, showContactSection, searchTerm, isRequestingLocation, locationWarning, selectedDay } = this.state;

    const { t, i18n } = this.props;

    if (loading) {
      return <LoadingPage message={t('home.loading')} />;
    }

    return (
      <>
        <SEO
          title={(() => {
            const isEn = this.props.i18n?.language === 'en';
            const oggi = new Date();
            if (isEn) {
              const day = oggi.toLocaleDateString('en-GB', { weekday: 'long' });
              const date = oggi.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
              return `Things to do ${day.charAt(0).toUpperCase()+day.slice(1)} ${date} — Events near you in Italy | Happy Events`;
            }
            const giorno = oggi.toLocaleDateString('it-IT', { weekday: 'long' });
            const data = oggi.toLocaleDateString('it-IT', { day: 'numeric', month: 'long' });
            return `Cosa fare ${giorno.charAt(0).toUpperCase()+giorno.slice(1)} ${data} — Eventi vicino a te | Happy Events`;
          })()}
          description={this.props.i18n?.language === 'en'
            ? 'Discover concerts, shows, exhibitions and parties near you today and this weekend in Italy. Free, no registration required. Find your perfect event!'
            : "Scopri concerti, aperitivi, mostre e spettacoli vicino a te oggi e questo weekend. Gratis, senza registrazione. Trova l'evento perfetto e conosci chi ci va!"}
          keywords={this.props.i18n?.language === 'en'
            ? 'events in Italy tonight, things to do in Italy, concerts in Italy, Italian events today, events near me Italy, free events Italy, what to do this weekend Italy'
            : 'eventi stasera, cosa fare oggi, concerti stasera, eventi vicino a me, cosa fare questo weekend, eventi gratis, spettacoli, aperitivi'}
          url="https://eventhappy.it"
        />
        <JsonLd data={this.generateStructuredData()} />

        <Container className="my-4" id="events-section">
          <DebugPanel show={showDebug} events={events} filteredEvents={events} activeFilters={activeFilters} />

          {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

          {/* Search bar */}
          <div style={{ marginBottom: '1.5rem' }}>
            <Form onSubmit={this.handleSearch}>
              <div style={{ position: 'relative', display: 'flex', gap: '0.5rem' }}>
                <div style={{ position: 'relative', flex: 1 }}>
                  <span style={{
                    position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)',
                    color: 'var(--text-muted)', pointerEvents: 'none', fontSize: '1rem'
                  }}>🔍</span>
                  <Form.Control
                    type="text"
                    placeholder={t('home.search_placeholder')}
                    value={searchTerm}
                    onChange={this.handleSearchChange}
                    style={{ paddingLeft: '2.75rem', paddingRight: searchTerm ? '2.75rem' : '1rem', height: '48px', fontSize: '0.95rem' }}
                  />
                  {searchTerm && (
                    <button type="button" onClick={this.handleResetSearch} style={{
                      position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)',
                      background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', fontSize: '1.1rem', lineHeight: 1
                    }}>✕</button>
                  )}
                </div>
                <Button type="submit" style={{
                  height: '48px', paddingLeft: '1.5rem', paddingRight: '1.5rem',
                  background: 'var(--gradient)', border: 'none', borderRadius: 'var(--radius-full)',
                  fontWeight: 600, fontSize: '0.9rem', whiteSpace: 'nowrap',
                  boxShadow: '0 4px 14px rgba(124,58,237,0.35)'
                }}>
                  {t('home.search_btn')}
                </Button>
              </div>
            </Form>
          </div>

          {/* Location chip */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
            <button
              onClick={this.requestLocation}
              disabled={isRequestingLocation}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
                padding: '0.4rem 1rem', borderRadius: '9999px', cursor: 'pointer',
                background: userLocation ? 'rgba(16,185,129,0.1)' : 'var(--surface)',
                border: `1.5px solid ${userLocation ? '#10B981' : 'var(--border)'}`,
                color: userLocation ? '#065F46' : 'var(--text-muted)',
                fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '0.82rem',
                transition: 'all 0.2s'
              }}
            >
              {isRequestingLocation ? '⏳' : userLocation ? '📍' : '🗺️'}
              {isRequestingLocation ? t('home.location_detecting') : userLocation ? t('home.within_km', { km: maxDistance }) : t('home.use_location')}
            </button>

            {userLocation && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="range" min="5" max="100" step="5" value={maxDistance}
                  onChange={(e) => this.handleDistanceChange(parseInt(e.target.value))}
                  style={{ width: '120px', accentColor: 'var(--primary)' }}
                />
                <label style={{ fontSize: '0.8rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                  <input
                    type="checkbox" checked={activeFilters.distance} onChange={this.toggleDistanceFilter}
                    style={{ accentColor: 'var(--primary)' }}
                  />
                  Filtra
                </label>
              </div>
            )}

            {locationWarning && (
              <span style={{ fontSize: '0.78rem', color: 'var(--accent)', background: '#FFFBEB', padding: '0.3rem 0.75rem', borderRadius: '9999px' }}>
                ⚠️ {locationWarning}
              </span>
            )}
            {locationError && (
              <span style={{ fontSize: '0.78rem', color: '#991B1B', background: '#FEF2F2', padding: '0.3rem 0.75rem', borderRadius: '9999px' }}>
                ⚠️ Posizione non disponibile
              </span>
            )}
          </div>

          {/* ── Day slidebar ── */}
          {availableDays.length > 0 && (
            <div style={{ marginBottom: '1.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', marginBottom: '1rem' }}>
                <h2 style={{ fontSize: '1.2rem', fontWeight: 800, margin: 0, color: '#f1f5f9' }}>
                  {activeFilters.search ? `"${activeFilters.search}"` : activeFilters.category || t('home.all_events')}
                </h2>
                {selectedDay && (() => {
                  const day = availableDays.find(d => d.date === selectedDay);
                  return day ? (
                    <span style={{ fontSize: '0.82rem', color: 'var(--text-muted)', fontWeight: 500 }}>
                      {day.count} {day.count === 1 ? t('home.event_count_one') : t('home.event_count_other')}
                    </span>
                  ) : null;
                })()}
              </div>
              <div style={{
                display: 'flex', gap: '0.5rem', overflowX: 'auto',
                paddingBottom: '0.5rem', scrollbarWidth: 'none', msOverflowStyle: 'none',
              }}>
                {availableDays.map(day => {
                  const isActive = selectedDay === day.date;
                  return (
                    <button
                      key={day.date}
                      onClick={() => {
                        if (!isActive) {
                          this.setState({ selectedDay: day.date });
                          this.loadEventsForDay(day.date);
                        }
                      }}
                      style={{
                        flexShrink: 0, display: 'flex', flexDirection: 'column',
                        alignItems: 'center', padding: '0.45rem 1.1rem',
                        borderRadius: '9999px', border: 'none', cursor: 'pointer',
                        fontFamily: 'Poppins, sans-serif', transition: 'all 0.2s',
                        background: isActive ? 'var(--gradient)' : 'var(--surface)',
                        color: isActive ? '#fff' : 'var(--dark)',
                        boxShadow: isActive ? '0 4px 12px rgba(124,58,237,0.3)' : '0 1px 4px rgba(0,0,0,0.06)',
                      }}
                    >
                      <span style={{ fontWeight: 700, fontSize: '0.82rem', lineHeight: 1.2 }}>{day.label}</span>
                      {day.sublabel && (
                        <span style={{ fontWeight: 500, fontSize: '0.7rem', opacity: isActive ? 0.85 : 0.55 }}>{day.sublabel}</span>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* ── Events ── */}
          {eventsLoading ? (
            <LoadingPage message="" />
          ) : events.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '4rem 0', color: 'var(--text-muted)' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔍</div>
              <p style={{ fontWeight: 600, fontSize: '1.1rem' }}>{t('home.no_events')}</p>
              <p style={{ fontSize: '0.9rem' }}>{t('home.no_events_sub')}</p>
            </div>
          ) : (
            <Cards events={events} />
          )}

          {/* Community & Match teaser */}
          <CommunityTeaser />

          {/* Sezione Chi Siamo */}
          <div style={{ marginTop: '4rem' }}>
            <AboutSection />
          </div>

          {/* FAQ – targeting "cosa fare stasera", "eventi vicino a me", ecc. */}
          <FAQSection />

          {showContactSection && <ContactSection id="contact-section" />}
        </Container>
      </>
    );
  }
}

export default withTranslation()(Main);